// Handling login APIs

jQuery(function ($) {
  const temaEnv = window?.drupalSettings?.tema;
  const baseUrl = temaEnv?.sna_accesspass_api;
  const apiToken = temaEnv?.sna_accesspass_api_token;

  // const formLogin = $("#login-modal");

  if (document.getElementById("login-modal")) {
    const loginSubmitButton = document.getElementById("loginSubmitButton");

    // const redirectPath = formLogin.data('redirect');
    // console.log(redirectPath);

    loginSubmitButton.addEventListener("click", (event) => {
      event.preventDefault(); // Prevent the form from submitting traditionally

      var username = $("#loginEmail").val();
      var password = $("#loginPassword").val();

      var data = {
        username: username,
        password: password,
      };

      // console.log(data);

      var userName;

      const loaderElement = document.querySelector(".loader-black");
      loaderElement.classList.add("active");

      $.ajax({
        url: baseUrl + "/auth/login",
        method: "POST",
        data: JSON.stringify(data),
        dataType: "json",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "Api-Token": apiToken,
        },
        success: function (response) {
          // Authentication successful
          // console.log(response);
          document.body.style.overflow = "auto";
          localStorage.setItem("login-token", response.result.token);
          localStorage.setItem(
            "user-response",
            JSON.stringify(response.result)
          );
          userName = response.result.first_name;

          var loginModal = document.getElementById("login-modal");
          if (loginModal) {
            loginModal.style.display = "none";
          }

          const user_response = localStorage.getItem("user-response");
          const userObject = JSON.parse(user_response);

          // console.log(userObject.first_name);
          if (userObject.first_name != null) {
            $("#top-name").html("Hallo, " + userObject.first_name);
          }
          $("#register-btn").show();
          $("#login-btn").hide();
          const miniHeaderLogin = document.querySelector(".miniHeaderLogin");
          const miniHeaderHello = document.querySelector(".miniHeaderHello");
          miniHeaderLogin.classList.add("hidden");
          miniHeaderLogin.classList.remove("menu-login");
          miniHeaderHello.classList.remove("hidden");
          miniHeaderHello.classList.add("menu-login");
        },
        error: function (error) {
          // Authentication error
          console.error("Login error:", error.responseJSON.message);
          document.getElementById("errorMessage").innerHTML =
            '<div class="error">' + error.responseJSON.message + "</div>";
          loaderElement.classList.remove("active");
        },
      });
    });
  }

  if (localStorage.getItem("user-response")) {
    const user_response = localStorage.getItem("user-response");
    const userObject = JSON.parse(user_response);

    // console.log(userObject.first_name);
    if (userObject.first_name != null) {
      $("#top-name").html("Hallo, " + userObject.first_name);
    }
    const miniHeaderLogin = document.querySelector(".miniHeaderLogin");
    const miniHeaderHello = document.querySelector(".miniHeaderHello");
    miniHeaderLogin.classList.add("hidden");
    miniHeaderHello.classList.remove("hidden");
  }

  $(".user-logout").on("click", function () {
    console.log("logging out...");

    const logout_token = localStorage.getItem("login-token");
    const user_response = localStorage.getItem("user-response");

    $.ajax({
      url: baseUrl + "/auth/logout",
      type: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Api-Token": apiToken,
        Authorization: "Bearer " + logout_token,
      },
      success: function (response) {
        // Logout successful
        // console.log(response);
        localStorage.removeItem("login-token"); // Correct the item name
        localStorage.removeItem("user-response"); // Correct the item name
        window.location = "/";
        localStorage.clear();
        sessionStorage.clear();
      },
      error: function (error) {
        // Handle error
      },
    });
  });
});
